import { Controller } from "@hotwired/stimulus"

// Shows a client-side thumbnail of the image a user picks in a file input,
// before it is uploaded. Uses an object URL and revokes it on replace/disconnect
// so we don't leak blobs. Non-image selections clear the preview.
export default class extends Controller {
  static targets = ["input", "image"]

  connect() {
    this.objectUrl = null
  }

  disconnect() {
    this.revoke()
  }

  preview() {
    const file = this.hasInputTarget && this.inputTarget.files && this.inputTarget.files[0]
    this.revoke()

    if (!file || !file.type.startsWith("image/")) {
      this.imageTarget.removeAttribute("src")
      this.imageTarget.classList.add("hidden")
      return
    }

    this.objectUrl = URL.createObjectURL(file)
    this.imageTarget.src = this.objectUrl
    this.imageTarget.classList.remove("hidden")
  }

  revoke() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  }
}
